import { connect } from 'react-redux'
import { IntlProvider, addLocaleData } from 'react-intl'
import de from 'react-intl/locale-data/de'
import fr from 'react-intl/locale-data/fr'
import es from 'react-intl/locale-data/es'
import zu from 'react-intl/locale-data/zu'
import ko from 'react-intl/locale-data/ko'
import zh from 'react-intl/locale-data/zh'
import pt from 'react-intl/locale-data/pt'
import ja from 'react-intl/locale-data/ja'
import it from 'react-intl/locale-data/it'
import id from 'react-intl/locale-data/id'
import ru from 'react-intl/locale-data/ru'
import * as bootupSelectors from 'services/bootup/selectors'

addLocaleData([...de,
               ...es,
               ...fr,
               ...zu,
               ...ko,
               ...zh,
               ...pt,
               ...ja,
               ...id,
               ...ru,
               ...it])

if (process.env.NODE_ENV !== 'production') {
  const ar = require('react-intl/locale-data/ar') // eslint-disable-line global-require
  addLocaleData(ar)
}

const mapIntlStateToProps = (state) => ({
  locale: bootupSelectors.selectLanguageCode(state),
  defaultLocale: 'en',
  messages: bootupSelectors.selectMessages(state),
})

export default connect(mapIntlStateToProps)(IntlProvider)
